// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimsTeamCreateDto
 */
export interface IClaimsTeamCreateDto {
    /**
     * 
     * @type {string}
     * @memberof IClaimsTeamCreateDto
     */
    name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof IClaimsTeamCreateDto
     */
    allowed_services?: Array<number>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IClaimsTeamCreateDto
     */
    assigned_organizations_ids?: Set<number>;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimsTeamCreateDto
     */
    is_generic_claims_team: boolean;
}

/**
 * Check if a given object implements the IClaimsTeamCreateDto interface.
 */
export function instanceOfIClaimsTeamCreateDto(value: object): value is IClaimsTeamCreateDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('is_generic_claims_team' in value) || value['is_generic_claims_team'] === undefined) return false;
    return true;
}

export function IClaimsTeamCreateDtoFromJSON(json: any): IClaimsTeamCreateDto {
    return IClaimsTeamCreateDtoFromJSONTyped(json, false);
}

export function IClaimsTeamCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimsTeamCreateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'allowed_services': json['allowed_services'] == null ? undefined : json['allowed_services'],
        'assigned_organizations_ids': json['assigned_organizations_ids'] == null ? undefined : new Set(json['assigned_organizations_ids']),
        'is_generic_claims_team': json['is_generic_claims_team'],
    };
}

export function IClaimsTeamCreateDtoToJSON(json: any): IClaimsTeamCreateDto {
    return IClaimsTeamCreateDtoToJSONTyped(json, false);
}

export function IClaimsTeamCreateDtoToJSONTyped(value?: IClaimsTeamCreateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'allowed_services': value['allowed_services'],
        'assigned_organizations_ids': value['assigned_organizations_ids'] == null ? undefined : Array.from(value['assigned_organizations_ids'] as Set<any>),
        'is_generic_claims_team': value['is_generic_claims_team'],
    };
}

